// extracted by mini-css-extract-plugin
module.exports = {"resultSection":"TransferResultSection_resultSection__3e_yU"};